// @flow
import moment from 'moment';
import Uri from 'urijs';

import { initAppContext } from 'Context/initAppContext';
import { getCurrentLocale, getCurrentUri } from 'Utils/context/contextUtils';
import { httpHeaders, url } from '@clubmed/utils';
import { get } from 'lodash';
import domainsService from '@clubmed/domains-service';

export const createAppContextFromProps = (appContext: AppContext): AppContext => {
  const uri = new Uri(appContext.originalUrl);
  const hostname = uri.hostname();

  return {
    ...appContext,
    availableLocales: domainsService.forHostname(hostname).getAllLocales(),
    ...initAppContext(appContext.originalUrl, appContext),
  };
};

export const createAppContextFromReq = (req: express$Request): AppContext => {
  // $FlowFixMe: id is injected from express-request-id
  const requestId = req.headers[httpHeaders.X_REQUEST_ID] || req.id;

  const uri = getCurrentUri(req);
  const queryParameters = url.decodeQueryParameters(uri.query(true));
  const requestedLocale = queryParameters.locale;
  const hostname = uri.hostname();

  // $FlowFixMe we have a host
  const host: string = req.get('host');
  const appContext = {
    availableLocales: domainsService.forHostname(hostname).getAllLocales(),
    originalUrl: req.protocol + '://' + host + req.originalUrl,
    cookies: req.cookies,
    locale: getCurrentLocale(requestedLocale, hostname),
    requestId,
    userAgent: req.headers['user-agent'],
  };
  moment.locale(get(appContext.availableLocales, `${appContext.locale}.moment`, 'fr'));

  return { ...appContext, ...initAppContext(uri, appContext) };
};
